import React, { useMemo } from 'react';
import {
  IBasicFilterFieldsFragment,
  IConditionFieldsFragment,
} from '../../../../../utils/apollo/graphqlSchema';
import { useDndEntityInternalContext } from '../../../../DndEntity';
import { IRowMeta } from '../../../../../redux/slices/oldBuilder';
import { getDndActiveItemData } from '../../../../DndEntity/utils';
import BasicFilterConditionDroppable from './BasicFilterConditionDroppable';
import BasicFilterConditionPredicate from './BasicFilterConditionPredicate';
import * as BasicFilterViewUI from '../BasicFilterViewUI';

interface IProps {
  rowMeta?: IRowMeta;
  filter: IBasicFilterFieldsFragment;
  condition: IConditionFieldsFragment;
  conditionIndex: number;
  keyPrefix: string;
}

const BasicFilterCondition = ({
  rowMeta,
  filter,
  condition,
  conditionIndex,
  keyPrefix,
}: IProps) => {
  const { predicates, logicOps } = condition;

  const dndContext = useDndEntityInternalContext();
  const showAddFilterDropzone = useMemo(() => {
    if (dndContext) {
      const data = getDndActiveItemData(dndContext.activeItem);

      return data && data.__typename === 'TagLeafField';
    }
    return false;
  }, [dndContext]);

  if (rowMeta && showAddFilterDropzone) {
    return (
      <BasicFilterConditionDroppable
        rowMeta={rowMeta}
        filter={filter}
        conditionIndex={conditionIndex}
        predicateIndex={predicates.length}
      >
        {predicates.map((predicate, predicateIndex) => (
          <BasicFilterConditionPredicate
            key={`${keyPrefix}-${predicateIndex}`}
            predicate={predicate}
            predicateIndex={predicateIndex}
            logicOp={logicOps?.[predicateIndex]}
            keyPrefix={keyPrefix}
          />
        ))}
      </BasicFilterConditionDroppable>
    );
  } else {
    return (
      <>
        <BasicFilterViewUI.Bracket>(</BasicFilterViewUI.Bracket>
        {predicates.map((predicate, predicateIndex) => (
          <BasicFilterConditionPredicate
            key={`${keyPrefix}-${predicateIndex}`}
            predicate={predicate}
            predicateIndex={predicateIndex}
            logicOp={logicOps?.[predicateIndex]}
            keyPrefix={keyPrefix}
          />
        ))}
        <BasicFilterViewUI.Bracket>)</BasicFilterViewUI.Bracket>
      </>
    );
  }
};

export default BasicFilterCondition;
